
import { defineComponent, PropType } from 'vue'
import deviceHeader from '@/assets/imgs/header.webp'
import deviceFooter from '@/assets/imgs/footer.webp'
import wxAdd from '@/assets/imgs/wx-add.webp'
import wxFace from '@/assets/imgs/wx-face.webp'
import wxVoice from '@/assets/imgs/wx-voice.webp'
import { Introduction } from '@/types'

export default defineComponent({
  name: 'Introduction',
  props: {
    config: {
      type: Object as PropType<Introduction>,
      required: true
    }
  },
  data () {
    return {
      deviceHeader,
      deviceFooter,
      wxAdd,
      wxFace,
      wxVoice
    }
  },
  methods: {
    start () {
      this.$emit('start')
    }
  }
})
